import React, { useContext, useState } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import { ILocation } from '../types';

export const LocationContext = React.createContext<ILocation>({} as ILocation);
export const useLocationContext = () => useContext(LocationContext);

// TODO remove this context and put the email stuff somewhere else... auth provider maybe?
export function LocationProvider(props: IBaseProps) {
  const [signUpEmail, setSignUpEmail] = useState<string>('');

  const value: ILocation = {
    signUpEmail,
    setSignUpEmail,
  };

  return <LocationContext.Provider value={value}>{props.children}</LocationContext.Provider>;
}

export const LocationConsumer = LocationContext.Consumer;
